import { Session } from "../../Types/Generated/LogbookApi/Session"
import { accountSessionResult } from "../AccountSession"
import { entity } from "./Connection"

export const AccountEntity = entity("Account", {
  fetch: (client, { accountId }) => {
    if (accountId === undefined) {
      return Promise.reject(new Error("Account fetch requires accountId"));
    }
    return new Session(client).session.get({ params: {} }).call().then((response) =>
      response.session.accountId === accountId
        ? accountSessionResult(response)
        : { entities: { Account: [], AccountUser: [] } },
    );
  },
});
